__turbopack_context__.v({
  "policy-section": "policy-sections-module-scss-module__BhRdIW__policy-section",
  "policy-section--content": "policy-sections-module-scss-module__BhRdIW__policy-section--content",
  "policy-section--subsection": "policy-sections-module-scss-module__BhRdIW__policy-section--subsection",
  "policy-sections": "policy-sections-module-scss-module__BhRdIW__policy-sections",
});
